import { toast } from 'react-toastify'

export default {
  ValidateForm(form,is_lite = false){
    if(!form.name){
      toast.warning("Name is empty!")
      return false
    }else if(!form.tag){
      toast.warning("Tag is empty!")
      return false
    }else if(!form.description){
      toast.warning("Description is empty!")
      return false
    }else if(!form.type && !is_lite ){
      toast.warning("Type is empty!")
      return false
    }else if(!form.address){
      toast.warning("Address is empty!")
      return false
    }else if(!form.latitude){
      toast.warning("Latitude is empty!")
      return false
    }else if(!form.longitude){
      toast.warning("Longitud is empty!")
      return false
    }else if(!form.city){
      toast.warning("City is empty!")
      return false
    }else if(!form.postal_code){
      toast.warning("Postal is empty!")
      return false
    }else if(!form.project_name){
      toast.warning("Project name is empty!")
      return false
    }else if(!form.contact && !is_lite){
      toast.warning("Contact is empty!")
      return false
    }else if(!form.status){
      toast.warning("Status is empty!")
      return false
    }
    return true
  },
  ValidateFormLocation(form,is_lite = false){
     if(!form.name){
      toast.warning("Location Name is empty!")
      return false
    } else if((Object.keys(form.contact) < 1) && !is_lite){
      console.log(is_lite)
      toast.warning("Location Contact is empty!")
      return false
    } else if(!form.description) {
      toast.warning("Location Description is empty!")
      return false
    } else if(!form.site){
      toast.warning("Site is empty!")
      return false
    }
    return true
  },
}



// WEBPACK FOOTER //
// ./src/App/location/site/helper/form.js